import { React, useState, useEffect } from "react";
import { Button, Icon, Modal, Grid } from "semantic-ui-react";
import { reject } from "lodash";
import PropTypes from "prop-types";

// Redux
import { connect } from "react-redux";

// Components
import NewTable from "@Components/NewTable";

// Styles
import styles from "./styles.module.css";

const ContactsFilter = ({ onClose, onRemove, selectedContact, tableColumns, disabled }) => {
	// hooks
	const [filteredItems, setFilteredItems] = useState([]);
	const [selectedItems, setSelectedItems] = useState([]);

	// useEffects
	useEffect(() => {
		setFilteredItems(selectedContact);
	}, []);

	// saveHandlers
	const handlerTable = (name, item) => {
		if (name === "Eraser") {
			setFilteredItems(reject(filteredItems, { id: item.id }));
		}
	};

	const save = () => {
		onRemove(filteredItems);
	};

	return (
		<div>
			<Modal
				open
				closeIcon
				className={styles.modalFirst}
				onClose={() => {
					onClose();
				}}>
				<Modal.Header className={styles.modalHeader}>
					<Icon name="eye" />
					Ver Seleccionados
				</Modal.Header>
				<Modal.Content className={styles.modalContent} scrolling>
					<Grid className={styles.container} columns={1}>
						<Grid.Column className={styles.columns}>
							<NewTable
								data={filteredItems}
								columns={[
									{
										label: "Acciones",
										action: [{ content: "trash", color: "#b43333", onClick: "Eraser", type: "icon" }],
										dataPosition: "center",
										width: 1,
										canFilter: false,
										canSort: false,
										hidden: disabled,
									},
									...tableColumns,
								]}
								defaultOrder={{ key: "name", dir: "asc" }}
								pageRows={7}
								searchable
								searchPosition="left"
								onMultipleChange={(item) => {
									return setSelectedItems(item);
								}}
								multipleSelected={selectedItems}
								handlerTable={handlerTable}
							/>
						</Grid.Column>
					</Grid>
				</Modal.Content>
				<Modal.Actions className={styles.modalFooter}>
					<Button
						className={styles.negativeButton}
						onClick={() => {
							onClose();
						}}>
						Atrás
					</Button>
					<Button className={styles.positiveButton} onClick={save}>
						Modificar
					</Button>
				</Modal.Actions>
			</Modal>
		</div>
	);
};

function mapStateToProps({ user }) {
	return {
		user,
	};
}

ContactsFilter.propTypes = {
	onClose: PropTypes.func,
	selectedContact: PropTypes.func,
	onRemove: PropTypes.func,
	tableColumns: PropTypes.array,
	disabled: PropTypes.bool,
};

export default connect(mapStateToProps)(ContactsFilter);
